import React, { memo } from "react";
import CategoryCard from "../common/CategoryCard";
import Banner from "./Banner";

const GridView = ({ top, middle, bottom, promo1, promo2, vendor }) => {
  return (
    <div className="w-full box-border">
      {/* Top */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-y-5 w-full border-inherit">
        {top.map((category, index) => (
          <CategoryCard
            category={{
              ...category,
              buttonLink: `/collections/${category.handle}`,
              buttonText: "Explore",
              products: category?.tagProducts?.length || 0,
              vendor,
            }}
            key={index}
          />
        ))}
      </div>
      {/* Middle */}
      <div className="grid grid-cols-2 md:grid-cols-4 grid-rows-2 gap-y-5 w-full my-10 border-inherit">
        <div className="col-span-2 row-span-2 w-full h-full border-inherit">
          <Banner
            title={promo1.title}
            description={promo1.description.description}
            buttonText={promo1?.buttonText}
            buttonLink={promo1?.buttonLink}
            bgImage={promo1.backgroundImage}
            paddingBottom="100%"
          />
        </div>
        {middle.map((category, index) => (
          <CategoryCard
            category={{
              ...category,
              buttonLink: `/collections/${category.handle}`,
              buttonText: "Explore",
              products: category?.tagProducts?.length || 0,
              vendor,
            }}
            key={index}
          />
        ))}
      </div>
      {/* Promo2 */}
      <Banner
        title={promo2.title}
        description={promo2.description.description}
        buttonText={promo2?.buttonText}
        buttonLink={promo2?.buttonLink}
        bgImage={promo2.backgroundImage}
      />
      {/* Bottom */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-y-5 w-full border-inherit">
        {" "}
        {bottom.map((category, index) => (
          <CategoryCard
            category={{
              ...category,
              buttonLink: `/collections/${category.handle}`,
              buttonText: "Explore",
              products: category?.tagProducts?.length || 0,
              vendor,
            }}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default memo(GridView);
